if (!customElements.get('marobali-made-to-order')) {
  customElements.define(
    'marobali-made-to-order',
    class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.note = this.querySelector('.marobali-order-note');
        const data = this.querySelector('[data-marobali-variants]');

        if (!this.section || !this.note || !data) return;

        this.variants = JSON.parse(data.textContent);
        this.optionIndex = Number(this.dataset.optionIndex);

        this.onChange = () => {
          this.update();
          requestAnimationFrame(() => {
            if (this.isConnected) this.update();
          });
        };

        this.section.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
      }

      normalize(value) {
        return String(value || '').trim().toLocaleLowerCase('fr');
      }

      isOrderMode(value) {
        return [
          'en stock',
          'fabrication à la commande'
        ].includes(this.normalize(value));
      }

      update() {
        const labels = [...this.section.querySelectorAll('label')];

        this.section.querySelectorAll('input[type="radio"]').forEach(input => {
          if (!this.isOrderMode(input.value)) return;

          const label = labels.find(
            item => input.id && item.htmlFor === input.id
          ) || input.closest('label');

          if (!label) return;

          label.classList.add('marobali-mode-label');
          label.classList.toggle('is-selected', input.checked);
        });

        const selectedMode = [
          ...this.section.querySelectorAll(
            'input[type="radio"]:checked, select'
          )
        ].find(control => this.isOrderMode(control.value));

        let mode = selectedMode?.value;

        if (!selectedMode) {
          const variantInput = this.section.querySelector(
            'form[action*="/cart/add"] [name="id"]'
          );

          const variantId =
            variantInput?.value || this.dataset.initialVariantId;

          const variant = this.variants.find(
            item => String(item.id) === String(variantId)
          );

          mode = variant?.options[this.optionIndex];
        }

        this.note.hidden =
          this.normalize(mode) !== 'fabrication à la commande';
      }
    }
  );
}
/* Fiche produit : un seul accordéon ouvert à la fois */
document.addEventListener('change', (event) => {
  const checkbox = event.target;

  if (
    !(checkbox instanceof HTMLInputElement) ||
    !checkbox.matches('.thb-tab > input[type="checkbox"]') ||
    !checkbox.checked
  ) {
    return;
  }

  const productInfo = checkbox.closest('.product-information');
  if (!productInfo) return;

  productInfo
    .querySelectorAll('.thb-tab > input[type="checkbox"]')
    .forEach((other) => {
      if (other !== checkbox) {
        other.checked = false;
      }
    });
});

if (!customElements.get('marobali-cart-quantity')) {
  class MarobaliCartQuantity extends HTMLElement {
    connectedCallback() {
      if (this.boundClick) return;

      this.boundClick = this.onClick.bind(this);
      this.addEventListener('click', this.boundClick);
    }

    async onClick(event) {
      const button = event.target.closest('button[data-step]');
      if (!button || button.disabled || this.busy) return;

      event.preventDefault();

      const drawer = this.closest('cart-drawer');
      if (!drawer || typeof drawer.updateQuantity !== 'function') return;

      const current = Number(this.dataset.quantity);
      const next = current + Number(button.dataset.step);

      if (!Number.isInteger(next) || next < 1) return;

      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('button').forEach((btn) => {
        btn.disabled = true;
      });

      try {
        await drawer.updateQuantity(this.dataset.index, String(next));
      } catch (error) {
        console.error('Impossible de modifier la quantité.', error);
      } finally {
        if (this.isConnected) {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.querySelectorAll('button').forEach((btn) => {
            btn.disabled =
              btn.dataset.step === '-1' &&
              Number(this.dataset.quantity) <= 1;
          });
        }
      }
    }
  }

  customElements.define('marobali-cart-quantity', MarobaliCartQuantity);
}

/* Fiche produit (mobile) : la galerie ne change de photo que sur un vrai glissement horizontal.
   Un glissement vertical (pour descendre dans la page) ne fait plus défiler les photos. */
(function () {
  function patch(el) {
    var f = el.flkty || (window.Flickity && window.Flickity.data(el));
    if (!f) return false;
    if (f._mbSwipe) return true;
    f._mbSwipe = true;
    f.on('pointerDown', function () { f._mbAxis = null; });
    f.hasDragStarted = function (v) {
      var ax = Math.abs(v.x), ay = Math.abs(v.y);
      if (f._mbAxis === 'y') return false;
      if (!f._mbAxis && ay > 6 && ay >= ax) { f._mbAxis = 'y'; return false; }
      if (ax > 16 && ax > ay * 1.5) { f._mbAxis = 'x'; return true; }
      return false;
    };
    return true;
  }
  function scan() {
    var ok = true;
    document.querySelectorAll('product-slider').forEach(function (el) {
      if (!patch(el)) ok = false;
    });
    return ok;
  }
  var tries = 0;
  (function loop() { if (!scan() && tries++ < 40) setTimeout(loop, 250); })();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 400);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
